<ng-container *ngIf="hasPermission">
  <ng-container *ngIf="viewMode === 'sidebar'">
    <div class="header">
      <h5>{{ 'workflow.menu.title' | translate }}</h5>
      <mmp5-mm-icons class="close" (click)="onCloseClick()" [icon]="['icon', 'icon-fechar']"></mmp5-mm-icons>
    </div>
  </ng-container>

  <div class="content" [class.content--embedded]="viewMode === 'embedded'">
    <div *ngIf="messageStatus" class="alert alert-{{ messageStatus }}">
      {{ messageText }}
    </div>
    <div class="workflow" *ngIf="workflow && inerithWorkflow">
      <p>{{ 'workflow.menu.' + type + '.inerithWorkflow' | translate }}</p>
    </div>
    <div *ngIf="workflow" class="card-workflow">
      <button class="btn-as-link" (click)="router.navigate(['workflow', 'edit', workflow?.id])">{{ workflow?.title }}</button>
      <p class="italic">{{ workflow?.description }}</p>
    <ng-template [ngIf]="workflow.fixedRevision">
        <p class="mb-0">
          <strong>{{ 'workflow.menu.fixedRevision' | translate }}</strong> - {{ workflow?.fixedRevisionDate }}
        </p>
    </ng-template>
    <ng-template [ngIf]="!workflow.fixedRevision">
        <p class="mb-0">
          <strong>{{ 'workflow.menu.revisionCycle' | translate }}</strong> - {{ workflow?.revisionPeriod }} {{ workflow?.revisionPeriodType }}
        </p>
    </ng-template>
      <p>
        <strong>{{ 'workflow.menu.flowResponsibles' | translate }}</strong> - {{ map() }}
      </p>
      <hr />
    </div>
    <div class="choose-workflow">
      <div class="inerith" *ngIf="inerithWorkflow">
        <div class="desc" *ngIf="workflowId == null">
          <p>{{ 'workflow.menu.' + type + '.emptyWorkflow' | translate }}</p>
          <p>{{ 'workflow.menu.' + type + '.changesDone' | translate }}</p>
          <hr />
        </div>
      </div>
      <h5>{{ 'workflow.menu.' + type + '.segregationType' | translate }}</h5>
      <p *ngIf="type == 'PAGE'">
        {{ 'workflow.menu.' + type + '.thisMoment' | translate }}
        <strong>{{ inerithWorkflow ? ('workflow.menu.' + type + '.inerith' | translate) : ('workflow.menu.' + type + '.segregated' | translate) }}</strong>
        {{ 'workflow.menu.workflowAttribution' | translate }}
        <strong>{{ workflowId }}</strong>
        {{ 'workflow.menu.' + type + '.originallyUsed' | translate }}
      </p>
      <p *ngIf="type == 'HOMEPAGE'">
        <ng-template [ngIf]="inerithWorkflow">
          {{ 'workflow.menu.ineritWorkflowHomepage' | translate }}
        </ng-template>
        <ng-template [ngIf]="!inerithWorkflow">
          {{ 'workflow.menu.segregatedWorkflowHomepage' | translate }}
        </ng-template>
      </p>
      <div class="d-flex justify-content-end">
        <div class="position-relative">
          <div class="card-remove-segregate" *ngIf="removeWorkflow">
            <p>{{ 'workflow.menu.' + type + '.flowsAlreadyInit' | translate }}</p>
            <div class="d-flex justify-content-end">
              <button class="btn btn-outline-dark me-1" (click)="removeWorkflow = false">
                {{ 'button.cancel' | translate }}
              </button>
              <button class="btn btn-primary" (click)="removeWorkSegregate()">
                {{ 'button.continue' | translate }}
              </button>
            </div>
          </div>
          <button *ngIf="!inerithWorkflow" (click)="removeWorkflow = true" class="btn btn-danger">
            <mmp5-mm-icons class="me-1" [icon]="['fa-solid', 'fa-trash-can']"></mmp5-mm-icons>
            {{ 'workflow.segreRemove' | translate }}
          </button>
        </div>
        <button *ngIf="inerithWorkflow" (click)="alertSegregate()" class="btn btn-secondary">
          <mmp5-mm-icons class="me-1" [icon]="['fa-solid', 'fa-sitemap']"></mmp5-mm-icons>
          {{ 'workflow.menu.' + type + '.segregateItem' | translate }}
        </button>
      </div>
      <div *ngIf="!inerithWorkflow && workflowId == null">
        <hr />
        <h5>{{ 'workflow.select' | translate }}</h5>
        <div class="row">
          <div class="col-12 col-lg-8 mb-2">
            <mmp5-fieldset-haruki
              [formControl]="workflowSelect"
              [key]="'workflowSelect'"
              [selectOptions]="workflowList || []">
            </mmp5-fieldset-haruki>
          </div>
          <div class="col-12 col-lg-4">
            <button [disabled]="workflowSelect.value == ''" (click)="sendWorkflow()" class="btn btn-secondary">
              {{ 'workflow.link' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
